export const DDC_MAP_VIEW_CHANGE = 'ddc.map.viewChange';

function viewChange(map) {
	return {
		eventType: DDC_MAP_VIEW_CHANGE,
		eventData: {
			// the map's container element, so pushEvent enrichment can
			// resolve the widget (widgetName/widgetHeading) it lives in
			element: map?.getDiv?.()
		}
	};
}

export default viewChange;
